import { IonIcon, IonItem, IonLabel } from '@ionic/react';
import {
  caretDownOutline,
  caretUpOutline,
  ribbonOutline,
  sadOutline,
} from 'ionicons/icons';
import { PlayerAvatar } from '../../../components/PlayerAvatar';

interface FantasyLeagueMemberProps {
  position: number;
  teamName: string;
  score: number | null | undefined;
  userPicture?: string | null;
  userName?: string;
  isLeader?: boolean;
  isLast?: boolean;
  positionChange?: 'up' | 'down' | 'same' | null;
  onClick?: () => void;
}

export const FantasyLeagueMember = ({
  position,
  teamName,
  score,
  userPicture,
  userName,
  isLeader,
  isLast,
  positionChange,
  onClick,
}: FantasyLeagueMemberProps) => {
  const displayScore = score !== null && score !== undefined ? score.toFixed(2) : '-';

  return (
    <IonItem button={!!onClick} detail={!!onClick} onClick={onClick}>
      <IonLabel>
        <div className="flex justify-between items-center">
          <div className="flex items-center gap-2 min-w-0">
            <span className="font-bold text-lg w-8 shrink-0">{position}</span>
            <PlayerAvatar image={userPicture} nick={userName || teamName} size="sm" />
            <span className="text-sm truncate">{teamName}</span>
            {isLeader && (
              <IonIcon icon={ribbonOutline} className="text-yellow-500 shrink-0" data-testid="icon-leader" />
            )}
            {isLast && (
              <IonIcon icon={sadOutline} className="text-red-500 shrink-0" data-testid="icon-last" />
            )}
          </div>
          <div className="flex items-center gap-1 shrink-0 ml-2">
            {positionChange === 'up' && (
              <IonIcon icon={caretUpOutline} className="text-green-600" data-testid="icon-position-up" />
            )}
            {positionChange === 'down' && (
              <IonIcon icon={caretDownOutline} className="text-red-500" data-testid="icon-position-down" />
            )}
            {positionChange === 'same' && (
              <span className="text-blue-600 font-bold">=</span>
            )}
            <span className="font-semibold">{displayScore}</span>
          </div>
        </div>
      </IonLabel>
    </IonItem>
  );
};
